import { connect } from 'react-redux'

import CustomerSuiteTitle from '../components/CustomerSuiteTitle'
import { getActiveCustomer } from '../selectors/customer'
import { makeGetActiveRevenueCenter } from '../selectors/revenueCenter'

const mapStateToProps = (state) => {
  const customer = getActiveCustomer(state)
  const suite = makeGetActiveRevenueCenter()(state)

  const customerSuiteTitle = `${suite.name} - ${customer.name ?? 'Anonymous'}`

  return { customerSuiteTitle }
}

export default connect(mapStateToProps, null)(CustomerSuiteTitle)
